export const mask = {
  mask: {
    background: 'rgba(0,0,0,0.1)',
    color: 'var(--p-text-color)',
  },
};
